import { type ReactNode, useId } from 'react';
import { Pill } from '../../../../pill/pill';
import { Item as ReadonlyItem, type ReadonlyListItem } from '../../item/readonly-list-item';
import styles from './change-notice.module.scss';

interface ChangeNoticeProps extends Omit<ReadonlyListItem, 'label'> {
  label?: ReactNode;
}

export function ChangeNotice({ label = 'Change', ...props }: ChangeNoticeProps) {
  const id = useId();

  return (
    <div className={styles.changeNotice}>
      <Pill className={styles.pill} variant="tertiary">
        {label}
      </Pill>
      <ReadonlyItem as="div" idPrefix={`change_${id}`} {...props} />
    </div>
  );
}
